import { Text, View } from '@react-pdf/renderer';
import { TableTitleStyle } from '../../../styles';

const styles = TableTitleStyle;

const InvoiceTitle = ({
  title,
  invoiceType,
  from,
  to,
  codeDetails,
  pageNumber,
}) => (
  <View>
    <View style={styles.titleContainer}>
      <Text style={styles.invoiceDate}> {pageNumber}</Text>
      <Text style={styles.invoiceDate}>
        {' '}
        {new Date(Date.now()).toLocaleString().split(',')[0]}
      </Text>
      <Text style={styles.invoiceDate}>
        {' '}
        {new Date().toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        })}
      </Text>
    </View>
    <View style={styles.titleContainer}>
      <Text style={styles.reportTitle}>{title}</Text>
      <Text style={styles.reportsubTitle}>{invoiceType}</Text>
      <View style={{ flexDirection: 'row' }}>
        <Text style={styles.date}>FROM {from} </Text>
        <Text style={styles.date}>TO {to}</Text>
      </View>
    </View>
    <View style={styles.codeDetails}>
      <Text style={styles.level2}>{codeDetails.codeLevel2} </Text>
      <Text style={styles.level2}>{codeDetails.descLevel2}</Text>
    </View>
    <View style={styles.codeDetails}>
      <Text style={styles.level3}>{codeDetails.codeLevel3} </Text>
      <Text style={styles.level3}>{codeDetails.descLevel3}</Text>
    </View>
  </View>
);

export default InvoiceTitle;

export const GenericInvoiceTitle = ({ titleData }) => (
  <>
    <View style={styles.titleContainer}>
      <View></View>
      <View style={styles.headingContainer}>
        <Text style={styles.reportHeading}>{titleData.heading}</Text>
        <Text style={styles.reportTitle}>{titleData.title}</Text>
        <Text style={styles.reportsubTitle}>{titleData.subTitle}</Text>
      </View>
      <View style={styles.rightContainer}>
        <Text style={styles.reportRightTitle}>
          {new Date(Date.now()).toLocaleString().split(',')[0]}
        </Text>
        <Text style={styles.reportRightSubTitle}>
          {new Date().toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          })}
        </Text>
      </View>
    </View>
    {titleData.title === 'Ledger' ? (
      <View style={styles.subContainerLedger}>
        <Text style={styles.reportLeftTitle}>{titleData.leftSubTitle}</Text>
        <Text style={styles.reportLeftTitle}>{titleData.leftTitle}</Text>
      </View>
    ) : (
      <></>
    )}
  </>
);

export const VoucherSubTitle = ({ subTitleData }) => (
  <View style={styles.subContainer}>
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
    >
      <Text style={styles.subheader}>
        {'Voucher Type: ' + subTitleData.type}
      </Text>
      <Text style={{ ...styles.subheader, fontFamily: 'Helvetica-Bold' }}>
        {'Voucher #: ' + subTitleData.number}
      </Text>
    </View>
    <Text style={styles.subheader}>
      {'Description: ' + subTitleData.description}
    </Text>
  </View>
);
